import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "accept", "multiple", "webkitdirectory"]


export default /*@__PURE__*/_defineComponent({
  __name: 'fileUpload',
  props: {
  id: {
    type: String,
    default: "",
  },
  accept: {
    type: String,
    default: "",
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  directory: {
    type: Boolean,
    default: false,
  },
  flatOnly: {
    type: Boolean,
    default: false,
  }
},
  emits: ['filesChanged'],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;

function handleFileChange(e) {
  let files = Array.from(e.target.files)
  
  // If flatOnly is true and directory mode is enabled, filter out nested files
  if (props.flatOnly && props.directory) {
    files = files.filter(file => {
      // webkitRelativePath format: "folderName/fileName" or "folderName/subfolder/fileName"
      const pathParts = file.webkitRelativePath.split('/')
      // Only include files directly in the root folder (2 parts: folder + filename)
      return pathParts.length === 2
    })
  }
  
  e.target.value = ''
  emits('filesChanged', files)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _mergeProps(_ctx.$attrs, { for: __props.id }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16, _hoisted_1),
    _createElementVNode("input", {
      type: "file",
      id: __props.id,
      accept: __props.accept,
      multiple: __props.multiple,
      webkitdirectory: __props.directory,
      hidden: "",
      onChange: handleFileChange
    }, null, 40, _hoisted_2)
  ], 64))
}
}

})